export type NoticeTone = "success" | "error";

export interface Notice {
  readonly tone: NoticeTone;
  readonly message: string;
}

const TONE_CLASS: Readonly<Record<NoticeTone, string>> = {
  success: "border-emerald-300 bg-emerald-50 text-emerald-900",
  error: "border-destructive/30 bg-destructive/5 text-destructive",
};

interface InlineNoticeProps {
  readonly notice: Notice;
  readonly testId: string;
}

/** A short outcome message ("saved", "could not save") shown next to the action that caused it. */
export function InlineNotice({ notice, testId }: InlineNoticeProps) {
  return (
    <p
      data-testid={testId}
      data-tone={notice.tone}
      role={notice.tone === "error" ? "alert" : "status"}
      className={`rounded-md border px-3 py-2 text-sm ${TONE_CLASS[notice.tone]}`}
    >
      {notice.message}
    </p>
  );
}
